<template>
  <div>
    <v-wait :for="waiterKeyword">
      <template slot="waiting">
        <div class="container loader">
          <div class="row justify-content-md-center">
            <div class="col-md-auto">
              <spinner></spinner>
            </div>
          </div>
        </div>
      </template>
      <validation-observer v-slot="{handleSubmit}" ref="formValidator">
        <form class="needs-validation" @submit.prevent="handleSubmit(formSubmit)">
          <div class="form-row">
            <div class="col-md-8">
              <base-input
                type="text"
                :label="$t('Course title')"
                :name="$t('Course title')"
                v-model="model.title"
                rules="required"
                labelClasses="required form-control-label"
                maxlength="250"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-4">
              <base-input
                rules="required"
                labelClasses="required form-control-label"
                :name="$t('Category')"
                :label="$t('Category')"
              >
                <el-select
                  v-model="model.category"
                  class="select-primary"
                  :placeholder="$t('Choose category')"
                >
                  <el-option
                    v-for="option in categories"
                    class="select-primary"
                    :key="option.id"
                    :value="option.id"
                    :label="option.title"
                  ></el-option>
                </el-select>
              </base-input>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-8">
              <base-input
                type="text"
                :label="$t('Course url name')"
                :name="$t('Course url name')"
                v-model="model.name"
                labelClasses="required form-control-label"
                placeholder="a-z, 0-9, _, -"
                :rules="{ required: true, regex: /^[a-z_0-9-]+$/, max: 32 }"
              >
                <template v-slot:infoBlock>
                  <small>{{ $t('courseUrl.infoBlock') }}</small>
                </template>
              </base-input>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-8">
              <base-input :label="$t('Description')" :name="$t('Description')">
                <textarea v-model="model.description" class="form-control" rows="3"></textarea>
              </base-input>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-8">
              <base-input
                type="text"
                :name="$t('Background gradient')"
                :label="$t('Background gradient')"
                v-model="model.properties.gradient"
              >
                <template v-slot:infoBlock>
                  <small v-html="$t('gradient.infoBlock')"></small>
                </template>
              </base-input>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-8">
              <transition>
                <card
                  type="frame"
                  class="text-white"
                  v-bind:style="{'background-image': model.properties.gradient || 'inherit'}"
                >
                  <h3 class="text-white">{{ model.title}}</h3>
                  <blockquote>{{model.description}}</blockquote>
                </card>
              </transition>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-4">
              <base-input :label="$t('Status')" :name="$t('Status')">
                <el-select v-model="model.status" class="select-primary">
                  <el-option class="select-primary" value="unpublished" :label="$t('Unpublished')"></el-option>
                  <el-option class="select-primary" value="published" :label="$t('Published')"></el-option>
                  <el-option class="select-primary" value="completed" :label="$t('Completed')"></el-option>
                  <el-option class="select-primary" value="announced" :label="$t('Announced')"></el-option>
                </el-select>
              </base-input>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-8">
              <base-input :label="$t('Pre knowledge')" :name="$t('Pre knowledge')">
                <textarea v-model="model.requirement" class="form-control" rows="3"></textarea>
              </base-input>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-4">
              <base-input
                :label="$t('Language')"
                :name="$t('Language')"
                labelClasses="required form-control-label"
                rules="required"
              >
                <el-select class="select-danger" v-model="model.language">
                  <el-option
                    v-for="option in languages"
                    class="select-danger"
                    :key="option.value"
                    :value="option.value"
                    :label="option.title"
                  ></el-option>
                </el-select>
              </base-input>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-8">
              <base-input :label="$t('Picture')">
                <file-input v-on:change="filesChange"></file-input>
              </base-input>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-3 col-sm-6">
              <base-input
                type="number"
                :label="$t('Price UAH')"
                :name="$t('Price UAH')"
                v-model="model.price.UAH"
              />
            </div>
            <div class="col-md-3 col-sm-6">
              <base-input
                type="number"
                :label="$t('Price USD')"
                :name="$t('Price USD')"
                v-model="model.price.USD"
              />
            </div>
            <div class="col-md-3 col-sm-6">
              <base-input
                type="number"
                :label="$t('Price EUR')"
                :name="$t('Price EUR')"
                v-model="model.price.EUR"
              />
            </div>
            <div class="col-md-3 col-sm-6">
              <base-input
                type="number"
                :label="$t('Price RUB')"
                :name="$t('Price RUB')"
                v-model="model.price.RUR"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-8">
              <base-input :label="$t('Tags')" :name="$t('Tags')">
                <tags-input class="form-control" v-model="model.properties.tags" />
                <template v-slot:infoBlock>
                  <small v-html="$t('tags.infoBlock')"></small>
                </template>
              </base-input>
            </div>
          </div>
          <base-button
            :loading="loading"
            type="success"
            native-type="submit"
          >{{ $t('Save settings') }}</base-button>
          <base-button
            :loading="loading"
            type="warning"
            @click="removeCourse"
          >{{ $t('Delete course') }}</base-button>
        </form>
      </validation-observer>
    </v-wait>
  </div>
</template>


<script>
import TagsInput from "@/components/Inputs/TagsInput";
import FileInput from "@/components/Inputs/FileInput";
import { Select, Option } from "element-ui";
import Spinner from "vue-spinner-component/src/Spinner.vue";
import { createNamespacedHelpers } from "vuex";
import courseApi from "../../../api/courses";
const { mapState, mapActions } = createNamespacedHelpers("course");

import {
  FormNotification,
  FormSubmitHandlers,
  FormEdit,
} from "../../../mixins/FormApiHandlers";
import { CourseForm } from "../../../mixins/Course/CourseForm";
import { tryExceptAwait } from "../../../utils";

export default {
  name: "FormEditCourse",

  data() {
    return {
      successMessage: this.$i18n.t("Course data successfully updated!"),
      errorMessage: this.$i18n.t("Error on updating course data!"),
      waiterKeyword: "course data fetching",
      submitRedirectTo: { name: "content", params: this.$route.params },
      picture: [],
    };
  },

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    TagsInput,
    FileInput,
    Spinner,
  },

  mixins: [FormNotification, FormSubmitHandlers, CourseForm, FormEdit],

  computed: {
    ...mapState({
      categories: (state) => state.categories,
      languages: (state) => state.languages,
      vuexModel: (state) => state.currentCourse,
      status: (state) => state.updateStatus.status,
    }),
  },
  methods: {
    ...mapActions({
      load: "loadCourse",
      save: "saveCourse",
      delete: "deleteCourse",
      loadCategories: "loadCategories",
      revertStatus: "revertUpdateStatus",
    }),
    filesChange(files) {
      this.picture = files;
    },
    async loadPredefined() {
      await this.loadCategories();
    },
    async formSubmit() {
      if (this.picture.length > 0) {
        const form = new FormData();
        form.append("file", this.picture[0]);
        const response = await tryExceptAwait(courseApi.uploadCoursePicture, [
          this.$route.params,
          form,
        ]);
        if (response.data && response.data.msg === "Done") {
          // console.log(response.data)
        } else {
          console.error(response.data);
        }
      }

      this.save({
        urlParams: this.$route.params,
        form: this.form,
      });
    },
    async removeCourse() {
      const answer = prompt("Вы хотите удалить курс. Это очень серьезно! " +
        "Введите URL имя курса для подтверждения удаления курса")
      if (answer === this.model.name) {
        await this.delete({urlParams: this.$route.params})
        await this.$router.push({name: "author-index"})
      }

    }
  },
};
</script>

<style scoped lang="scss">
.tags-input__wrapper {
  margin: 1rem 0;
  height: auto;
}
</style>
